(function (window) {
  'use strict';

  var SAMATRIP = window.SAMATRIP || {};
  var I18N = SAMATRIP.i18n || {};

  function t(key, fallback) {
    var map = (window.SAMATRIP && window.SAMATRIP.i18n) || I18N || {};
    var value = map[key];
    return value == null || value === '' ? (fallback || key) : value;
  }

  function tN(oneKey, otherKey, n, fallbackOne, fallbackOther) {
    var tpl = n > 1 ? t(otherKey, fallbackOther) : t(oneKey, fallbackOne);
    return String(tpl).replace('%n', String(n));
  }

  var KIWI_URL = 'https://mcp.kiwi.com/';
  var TRIVAGO_URL = 'https://mcp.trivago.com/mcp';
  var GEO_URL = 'https://geocoding-api.open-meteo.com/v1/search';
  var MAX_HOTELS = 30;

  var CITY_COORDS = {
    paris: [48.8566, 2.3522, 'FR'],
    casablanca: [33.5731, -7.5898, 'MA'],
    marrakech: [31.6295, -7.9811, 'MA'],
    marrakesh: [31.6295, -7.9811, 'MA'],
    agadir: [30.4278, -9.5981, 'MA'],
    rabat: [34.0209, -6.8416, 'MA'],
    tanger: [35.7595, -5.834, 'MA'],
    fes: [34.0331, -5.0003, 'MA'],
    istanbul: [41.0082, 28.9784, 'TR'],
    dubai: [25.2048, 55.2708, 'AE'],
    dubay: [25.2048, 55.2708, 'AE'],
    bali: [-8.4095, 115.1889, 'ID'],
    athenes: [37.9838, 23.7275, 'GR'],
    athens: [37.9838, 23.7275, 'GR'],
    barcelone: [41.3874, 2.1686, 'ES'],
    barcelona: [41.3874, 2.1686, 'ES'],
    rome: [41.9028, 12.4964, 'IT'],
    londres: [51.5074, -0.1278, 'GB'],
    london: [51.5074, -0.1278, 'GB'],
    newyork: [40.7128, -74.006, 'US'],
    madrid: [40.4168, -3.7038, 'ES'],
    lisbonne: [38.7223, -9.1393, 'PT'],
    lisbon: [38.7223, -9.1393, 'PT'],
    tokyo: [35.6762, 139.6503, 'JP'],
    bangkok: [13.7563, 100.5018, 'TH'],
    singapore: [1.3521, 103.8198, 'SG'],
    singapour: [1.3521, 103.8198, 'SG'],
    amsterdam: [52.3676, 4.9041, 'NL'],
    prague: [50.0755, 14.4378, 'CZ'],
    cairo: [30.0444, 31.2357, 'EG'],
    lecaire: [30.0444, 31.2357, 'EG'],
    maldives: [4.1755, 73.5093, 'MV'],
    male: [4.1755, 73.5093, 'MV'],
    cancun: [21.1619, -86.8515, 'MX'],
    'cancún': [21.1619, -86.8515, 'MX'],
    rio: [-22.9068, -43.1729, 'BR'],
    riodejaneiro: [-22.9068, -43.1729, 'BR']
  };

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function todayIso() {
    var d = new Date();
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function addDaysIso(days) {
    var d = new Date();
    d.setDate(d.getDate() + days);
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function isoToDmy(iso) {
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? m[3] + '/' + m[2] + '/' + m[1] : iso;
  }

  function nightsCount(checkin, checkout) {
    var start = new Date(checkin);
    var end = new Date(checkout);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 1;
    }
    var nights = Math.round((end - start) / 86400000);
    return nights > 0 ? nights : 1;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency || SAMATRIP.currency || 'EUR'
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseMcp(text) {
    var raw = String(text || '').trim();
    if (raw.charAt(0) === '{') {
      return JSON.parse(raw);
    }
    var chunks = raw.split(/\r?\n/).filter(function (line) {
      return line.indexOf('data:') === 0;
    }).map(function (line) {
      return line.slice(5).trim();
    });
    return JSON.parse(chunks[chunks.length - 1] || '{}');
  }

  function mcpText(parsed) {
    var content = (((parsed || {}).result || {}).content) || [];
    var text = '';
    content.forEach(function (part) {
      if (part && part.text) {
        text += part.text;
      }
    });
    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  }

  function mcpCall(url, method, params, headers) {
    return fetch(url, {
      method: 'POST',
      headers: Object.assign({
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/event-stream'
      }, headers || {}),
      body: JSON.stringify({
        jsonrpc: '2.0',
        id: Date.now(),
        method: method,
        params: params || {}
      })
    }).then(function (res) {
      return res.text().then(function (text) {
        return {
          ok: res.ok,
          session: res.headers.get('mcp-session-id'),
          parsed: parseMcp(text)
        };
      });
    });
  }

  function parseMoney(value) {
    var raw = String(value || '0').replace(/\u00a0/g, ' ').replace(/\s/g, '');
    return parseFloat(raw.replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
  }

  function cityKey(city) {
    return String(city || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');
  }

  function hotelRatingArg(stars) {
    var min = parseInt(stars, 10) || 0;
    if (min < 1 || min > 5) {
      return null;
    }
    var rating = {};
    for (var i = min; i <= 5; i += 1) {
      rating[i + 'star'] = true;
    }
    return rating;
  }

  function hotelFilterArg(query) {
    var filters = {};
    if (query.breakfast) {
      filters.breakfastIncluded = true;
    }
    if (query.wifi) {
      filters.freeWiFi = true;
    }
    if (query.pool) {
      filters.pool = true;
    }
    if (query.cancel) {
      filters.freeCancellation = true;
    }
    return Object.keys(filters).length ? filters : null;
  }

  function trivagoArgs(query, extra) {
    var adults = query.adults || 2;
    var rooms = query.rooms || 1;
    if (rooms > adults) {
      rooms = adults;
    }
    var args = Object.assign({
      arrival: query.checkin,
      departure: query.checkout,
      adults: adults,
      rooms: rooms,
      country: 'FR',
      currency: 'EUR',
      language: 'FR_FR'
    }, extra || {});
    var rating = hotelRatingArg(query.stars);
    if (rating) {
      args.hotel_rating = rating;
    }
    var filters = hotelFilterArg(query);
    if (filters) {
      args.filters = filters;
    }
    return args;
  }

  function mapKiwi(payload, query) {
    var list = (payload && payload.itineraries) || [];
    return list.slice(0, 12).map(function (item) {
      var outbound = item.outbound || {};
      var first = (outbound.segments || [])[0] || {};
      return {
        id: item.id,
        provider: 'SAMATRIP',
        title: (first.fromCity || query.origin) + ' → ' + (first.toCity || query.destination),
        airline: first.carrierName || first.carrier || t('airline', 'Compagnie aérienne'),
        flight_number: first.flightNumber || '',
        depart_at: outbound.departureTime || query.depart,
        origin: outbound.from || query.origin,
        destination: outbound.to || query.destination,
        stops: outbound.stops || 0,
        cabin: outbound.cabinClass || 'Economy',
        price_cents: Math.round((item.price || 0) * 100),
        currency: payload.currency || 'EUR',
        available: true
      };
    });
  }

  function mapTrivago(payload, query) {
    if (typeof payload === 'string') {
      var match = payload.match(/\{[\s\S]*\}\s*$/);
      if (match) {
        try {
          payload = JSON.parse(match[0]);
        } catch (e) {
          payload = {};
        }
      }
    }
    var rows = [];
    if (payload && typeof payload.output === 'string') {
      try {
        rows = JSON.parse(payload.output);
      } catch (e) {
        rows = [];
      }
    } else if (Array.isArray(payload)) {
      rows = payload;
    }
    return rows.slice(0, MAX_HOTELS).map(function (item) {
      var stay = parseMoney(item.price_per_stay || item.price_per_night);
      var night = parseMoney(item.price_per_night || stay);
      var image = String(item.main_image || '');
      if (image.indexOf('https://') !== 0) {
        image = '';
      }
      return {
        id: item.accommodation_id,
        provider: 'SAMATRIP',
        title: item.accommodation_name || t('hotel', 'Hôtel'),
        city: item.country_city || query.destination,
        stars: item.hotel_rating || 0,
        rating: item.review_rating || '',
        reviews: item.review_count || '',
        amenities: item.top_amenities || '',
        distance: item.distance || '',
        image: image,
        checkin: item.arrival || query.checkin,
        checkout: item.departure || query.checkout,
        price_cents: Math.round(stay * 100),
        night_cents: Math.round(night * 100),
        currency: item.currency || 'EUR',
        available: true
      };
    });
  }

  function searchKiwi(query) {
    var args = {
      flyFrom: query.origin,
      flyTo: query.destination,
      departureDate: isoToDmy(query.depart),
      adults: query.adults || 1
    };
    if (query.return) {
      args.returnDate = isoToDmy(query.return);
    }
    return mcpCall(KIWI_URL, 'tools/call', {
      name: 'search-flight',
      arguments: args
    }).then(function (res) {
      var payload = mcpText(res.parsed);
      var mapped = mapKiwi(payload, query);
      if (!mapped.length) {
        throw new Error('empty');
      }
      return { results: mapped, sources: ['SAMATRIP'], mode: 'live' };
    });
  }

  function geocode(city) {
    var key = cityKey(city);
    if (CITY_COORDS[key]) {
      return Promise.resolve({
        lat: CITY_COORDS[key][0],
        lng: CITY_COORDS[key][1],
        country: CITY_COORDS[key][2]
      });
    }
    return fetch(GEO_URL + '?name=' + encodeURIComponent(city) + '&count=1&language=fr&format=json')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var hit = (data.results || [])[0];
        if (!hit) {
          throw new Error('geo');
        }
        return { lat: hit.latitude, lng: hit.longitude, country: hit.country_code || 'FR' };
      });
  }

  function trivagoSession() {
    return mcpCall(TRIVAGO_URL, 'initialize', {
      protocolVersion: '2025-06-18',
      capabilities: {},
      clientInfo: { name: 'samatrip', version: '1.0' }
    }).then(function (init) {
      if (!init.session) {
        throw new Error('session');
      }
      var headers = { 'mcp-session-id': init.session };
      return mcpCall(TRIVAGO_URL, 'notifications/initialized', {}, headers).then(function () {
        return headers;
      });
    });
  }

  function searchTrivago(query) {
    return trivagoSession().then(function (headers) {
      return mcpCall(TRIVAGO_URL, 'tools/call', {
        name: 'trivago-accommodation-search',
        arguments: trivagoArgs(query, { query: query.destination })
      }, headers).then(function (res) {
        var mapped = mapTrivago(mcpText(res.parsed), query);
        if (mapped.length) {
          return { results: mapped, sources: ['SAMATRIP'], mode: 'live' };
        }
        return geocode(query.destination).then(function (geo) {
          return mcpCall(TRIVAGO_URL, 'tools/call', {
            name: 'trivago-accommodation-radius-search',
            arguments: trivagoArgs(query, {
              latitude: geo.lat,
              longitude: geo.lng
            })
          }, headers);
        }).then(function (res) {
          var fallback = mapTrivago(mcpText(res.parsed), query);
          if (!fallback.length) {
            throw new Error('empty');
          }
          return { results: fallback, sources: ['SAMATRIP'], mode: 'live' };
        });
      });
    });
  }

  function searchProxy(endpoint, query) {
    if (!endpoint) {
      return Promise.reject(new Error('no-endpoint'));
    }
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(query)
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('proxy');
      }
      return res.json();
    }).then(function (data) {
      if (!data || data.mode === 'sandbox') {
        throw new Error('sandbox');
      }
      var live = (data.results || []).filter(function (item) {
        return String(item.provider || '').toLowerCase().indexOf('sandbox') === -1
          && String(item.id || '').indexOf('sandbox-') !== 0;
      });
      if (!live.length) {
        var empty = new Error(data.message || 'empty');
        empty.userMessage = data.message || '';
        throw empty;
      }
      data.results = live;
      data.mode = 'live';
      return data;
    });
  }

  function searchFlights(query, endpoint) {
    return searchProxy(endpoint, Object.assign({ type: 'flight' }, query));
  }

  function searchHotels(query, endpoint) {
    return searchProxy(endpoint, Object.assign({ type: 'stay' }, query));
  }

  function stayBookRoom(root, offer, room, query) {
    updateStayRecap(root, offer, room);
    openStayDossier(root, offer, room, query);
  }

  function showToast(message, href) {
    var toast = qs('[data-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('data-toast', '');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toast.appendChild(span);
    if (href) {
      var link = document.createElement('a');
      link.href = href;
      link.textContent = t('view_cart', 'Voir le panier');
      toast.appendChild(link);
    }
    toast.classList.add('is-visible');
    setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  function cartAddUrl() {
    var url = (SAMATRIP.routes && SAMATRIP.routes.cartAdd) || '/cart/add';
    if (url.slice(-3) !== '.js') {
      url += '.js';
    }
    return url;
  }

  function addToCart(variantId, properties, options) {
    var id = String(variantId || '').replace(/\D/g, '');
    if (!id) {
      showToast(t('unavailable', 'Produit de réservation indisponible.'));
      return Promise.reject(new Error('variant'));
    }
    var clean = {};
    Object.keys(properties || {}).forEach(function (key) {
      var value = String(properties[key] == null ? '' : properties[key]).trim();
      if (value) {
        clean[key] = value.slice(0, 255);
      }
    });
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: Number(id),
          quantity: 1,
          properties: clean
        }]
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'cart');
          err.userMessage = err.message;
          throw err;
        }
        return data;
      }, function () {
        if (!res.ok) {
          throw new Error('cart');
        }
        return {};
      });
    }).then(function () {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = String((parseInt(el.textContent, 10) || 0) + 1);
      });
      if (options && options.redirect) {
        window.location.href = options.redirect;
        return;
      }
      showToast(t('added', 'Dossier ajouté au panier. Après paiement, SAMATRIP confirme sous 48 h.'), (SAMATRIP.routes && SAMATRIP.routes.cart) || '/cart');
    }).catch(function (err) {
      showToast((err && err.userMessage) || t('add_fail', 'Impossible d’ajouter au panier. Réessayez.'));
      return Promise.reject(err || new Error('cart'));
    });
  }

  var BOOKING_KEY = 'samatrip_booking';
  var FLIGHT_BOOKING_KEY = 'samatrip_flight_booking';

  function flightProperties(offer, query) {
    return {
      'Type de réservation': 'Vol',
      'Type de trajet': offer.trip_type || '',
      'Ville de départ': offer.origin || '',
      'Ville d\'arrivée': offer.destination || '',
      'Aéroport départ': offer.origin_id || '',
      'Aéroport arrivée': offer.destination_id || '',
      'Date départ': (offer.depart_at || '').slice(0, 10),
      'Date retour': offer.return_date || '',
      'Compagnie': offer.airline || '',
      'Vol': offer.flight_number || '',
      'Classe': offer.cabin || '',
      'Durée': offer.duration_label || '',
      'Escales': offer.stops ? String(offer.stops) : 'Direct',
      'Voyageurs': String((query && query.adults) || 1),
      'Prix live': money(offer.price_cents, offer.currency),
      'Confirmation': 'Dossier sous 48 h ouvrées',
      'Référence live': offer.id || ''
    };
  }

  function openFlightDossier(root, offer, query) {
    var url = root.getAttribute('data-dossier-url') || '/pages/dossier-vol';
    var payload = {
      type: 'flight',
      variantId: root.getAttribute('data-variant-id') || '',
      offer: offer,
      query: query || {},
      properties: flightProperties(offer, query)
    };
    try {
      sessionStorage.setItem(BOOKING_KEY, JSON.stringify(payload));
      sessionStorage.setItem(FLIGHT_BOOKING_KEY, JSON.stringify(payload));
    } catch (e) {
      showToast(t('dossier_fail', 'Impossible d’ouvrir le dossier. Réessayez.'));
      return;
    }
    window.location.href = url;
  }

  function openStayDossier(root, offer, room, query) {
    var url = root.getAttribute('data-dossier-url') || '/pages/dossier-sejour';
    var payload = {
      type: 'stay',
      variantId: root.getAttribute('data-variant-id') || '',
      offer: offer,
      room: room,
      query: query || {},
      properties: stayProperties(offer, room)
    };
    try {
      sessionStorage.setItem(BOOKING_KEY, JSON.stringify(payload));
    } catch (e) {
      showToast(t('dossier_fail', 'Impossible d’ouvrir le dossier. Réessayez.'));
      return;
    }
    window.location.href = url;
  }

  function passengerMarkup(index) {
    var n = String(index);
    return '' +
      '<article class="dossier-passenger">' +
        '<h3 class="dossier-passenger__title">Voyageur ' + n + '</h3>' +
        '<div class="form-grid">' +
          '<div class="form-field">' +
            '<label for="PassengerTitle' + n + '">Civilité</label>' +
            '<select id="PassengerTitle' + n + '" name="title_' + n + '" required>' +
              '<option value="M.">M.</option>' +
              '<option value="Mme">Mme</option>' +
              '<option value="Enfant">Enfant</option>' +
            '</select>' +
          '</div>' +
          '<div class="form-field">' +
            '<label for="PassengerBirth' + n + '">Date de naissance</label>' +
            '<input id="PassengerBirth' + n + '" type="date" name="birth_' + n + '" required>' +
          '</div>' +
          '<div class="form-field">' +
            '<label for="PassengerLast' + n + '">Nom (passeport)</label>' +
            '<input id="PassengerLast' + n + '" type="text" name="last_' + n + '" autocomplete="family-name" required>' +
          '</div>' +
          '<div class="form-field">' +
            '<label for="PassengerFirst' + n + '">Prénom (passeport)</label>' +
            '<input id="PassengerFirst' + n + '" type="text" name="first_' + n + '" autocomplete="given-name" required>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function bindBookingDossier(root) {
    var recap = qs('[data-dossier-recap]', root);
    var empty = qs('[data-dossier-empty]', root);
    var form = qs('[data-dossier-form]', root);
    var passengersBox = qs('[data-dossier-passengers]', root);
    if (!form) {
      return;
    }
    var expectedType = root.getAttribute('data-dossier-type') || 'flight';
    var payload = null;
    try {
      payload = JSON.parse(sessionStorage.getItem(BOOKING_KEY) || sessionStorage.getItem(FLIGHT_BOOKING_KEY) || 'null');
    } catch (e) {
      payload = null;
    }
    if (!payload || !payload.offer || (payload.type && payload.type !== expectedType)) {
      if (empty) {
        empty.hidden = false;
      }
      return;
    }
    var offer = payload.offer;
    var room = payload.room || {};
    var query = payload.query || {};
    var kind = payload.type || expectedType;
    var adults = Math.max(1, Math.min(6, parseInt(query.adults || room.occupancy, 10) || 1));
    if (recap) {
      recap.hidden = false;
      var route = qs('[data-recap-route]', recap);
      var airline = qs('[data-recap-airline]', recap);
      var flight = qs('[data-recap-flight]', recap);
      var dates = qs('[data-recap-dates]', recap);
      var cabin = qs('[data-recap-cabin]', recap);
      var price = qs('[data-recap-price]', recap);
      if (kind === 'stay') {
        if (route) {
          route.textContent = offer.title || offer.city || t('stay', 'Séjour');
        }
        if (airline) {
          airline.textContent = offer.city || '';
        }
        if (flight) {
          flight.textContent = room.name || '';
        }
        if (dates) {
          dates.textContent = (offer.checkin || '') + ' → ' + (offer.checkout || '');
        }
        if (cabin) {
            cabin.textContent = [room.beds, room.board, tN('night_one', 'night_other', room.nights || nightsCount(offer.checkin, offer.checkout), '%n nuit', '%n nuits')].filter(Boolean).join(' · ');
        }
        if (price) {
          price.textContent = money(room.price_cents || offer.price_cents, room.currency || offer.currency);
        }
        var media = qs('[data-recap-media]', recap);
        var photo = (room.images && room.images[0]) || room.image || offer.image || '';
        if (media) {
          if (photo) {
            media.hidden = false;
            media.innerHTML = '<img src="' + escapeHtml(photo) + '" alt="' + escapeHtml(room.name || offer.title || '') + '">';
          } else {
            media.hidden = true;
            media.innerHTML = '';
          }
        }
      } else {
        if (route) {
          route.textContent = (offer.origin || '') + ' → ' + (offer.destination || '');
        }
        if (airline) {
          airline.textContent = offer.airline || '';
        }
        if (flight) {
          flight.textContent = offer.flight_number || '';
        }
        if (dates) {
          dates.textContent = offer.return_date
            ? ((offer.depart_at || '').slice(0, 10) + ' → ' + offer.return_date)
            : ((offer.depart_at || '').slice(0, 10) + ' · Aller simple');
        }
        if (cabin) {
          cabin.textContent = [offer.cabin, offer.trip_type, offer.duration_label].filter(Boolean).join(' · ');
        }
        if (price) {
          price.textContent = money(offer.price_cents, offer.currency);
        }
      }
    }
    form.hidden = false;
    var variantInput = qs('[data-dossier-variant]', form);
    if (variantInput) {
      var variantId = String(payload.variantId || root.getAttribute('data-variant-id') || variantInput.value || '').replace(/\D/g, '');
      if (variantId) {
        variantInput.value = variantId;
      }
    }
    if (passengersBox) {
      var html = '';
      for (var i = 1; i <= adults; i += 1) {
        html += passengerMarkup(i);
      }
      passengersBox.innerHTML = html;
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) {
        return;
      }
      var status = qs('[data-dossier-status]', root);
      var submit = qs('[data-dossier-submit]', root);
      var baseProps = payload.properties || (kind === 'stay' ? stayProperties(offer, room) : flightProperties(offer, query));
      var properties = Object.assign({}, baseProps);
      properties['Email client'] = (qs('[name="email"]', form) || {}).value || '';
      properties['Téléphone'] = (qs('[name="phone"]', form) || {}).value || '';
      properties['Notes'] = (qs('[name="notes"]', form) || {}).value || '';
      var names = [];
      for (var p = 1; p <= adults; p += 1) {
        var title = (qs('[name="title_' + p + '"]', form) || {}).value || '';
        var last = (qs('[name="last_' + p + '"]', form) || {}).value || '';
        var first = (qs('[name="first_' + p + '"]', form) || {}).value || '';
        var birth = (qs('[name="birth_' + p + '"]', form) || {}).value || '';
        var line = [title, last.toUpperCase(), first, birth ? ('né(e) le ' + birth) : ''].filter(Boolean).join(' ');
        properties['Passager ' + p] = line;
        names.push((title + ' ' + last + ' ' + first).trim());
      }
      if (names[0]) {
        properties['Nom du voyageur'] = names[0];
      }
      if (submit) {
        submit.disabled = true;
      }
      if (status) {
        status.textContent = t('adding', 'Ajout au panier…');
      }
      var cartUrl = ((SAMATRIP.routes && SAMATRIP.routes.cart) || '/cart');
      addToCart(payload.variantId || root.getAttribute('data-variant-id'), properties, {
        redirect: cartUrl + (cartUrl.indexOf('?') >= 0 ? '&' : '?') + 'checkout=1'
      }).catch(function (err) {
        if (submit) {
          submit.disabled = false;
        }
        if (status) {
          status.textContent = (err && err.userMessage) || t('save_fail', 'Impossible d’enregistrer le dossier. Réessayez.');
        }
      });
    });
  }

  function formatTime(value) {
    if (!value) {
      return '';
    }
    var match = String(value).match(/(?:T| )(\d{2}:\d{2})/);
    if (match) {
      return match[1];
    }
    match = String(value).match(/(\d{2}:\d{2})/);
    return match ? match[1] : String(value);
  }

  function formatMinutes(mins) {
    mins = parseInt(mins, 10) || 0;
    if (mins <= 0) {
      return '';
    }
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    if (!h) {
      return m + ' min';
    }
    if (!m) {
      return h + ' h';
    }
    return h + ' h ' + pad(m);
  }

  function amenityList(value) {
    return String(value || '').split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean).slice(0, 4);
  }

  function liveRoomFallback(offer, query) {
    var nights = nightsCount(offer.checkin, offer.checkout);
    var adults = (query && query.adults) || 2;
    return [{
      id: (offer.id || 'hotel') + '-live',
      name: adults >= 2 ? t('room_double', 'Chambre Double') : t('room_single', 'Chambre Simple'),
      board: t('live_rate', 'Tarif live'),
      cancel: t('conditions', 'Selon conditions'),
      occupancy: adults,
      count: (query && query.rooms) || 1,
      nights: nights,
      price_cents: offer.price_cents || 0,
      night_cents: offer.night_cents || 0,
      currency: offer.currency || 'EUR',
      images: offer.image ? [offer.image] : [],
      image: offer.image || '',
      beds: '',
      details: '',
      description: ''
    }];
  }

  function searchLiveRooms(endpoint, offer, query) {
    if (!endpoint) {
      return Promise.resolve(liveRoomFallback(offer, query));
    }
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        type: 'rooms',
        hotel: offer.title || '',
        hotel_id: offer.id || offer.property_token || '',
        property_token: offer.property_token || offer.id || '',
        destination: offer.city || query.destination || offer.title || '',
        checkin: offer.checkin || query.checkin || '',
        checkout: offer.checkout || query.checkout || '',
        adults: query.adults || 2,
        rooms: query.rooms || 1
      })
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('rooms');
      }
      return res.json();
    }).then(function (data) {
      if (!data || data.mode === 'sandbox' || !(data.results || []).length) {
        throw new Error('empty');
      }
      return data.results;
    }).catch(function () {
      return liveRoomFallback(offer, query);
    });
  }

  function mergeRooms(primary, extra) {
    var seen = {};
    var rooms = [];
    (primary || []).concat(extra || []).forEach(function (room) {
      if (!room) {
        return;
      }
      var key = String(room.price_cents || 0);
      if (!key || seen[key]) {
        return;
      }
      seen[key] = true;
      rooms.push(room);
    });
    return rooms;
  }

  function stayProperties(offer, room) {
    var nights = room.nights || nightsCount(offer.checkin, offer.checkout);
    return {
      'Type de réservation': 'Séjour',
      'Destination séjour': offer.city || offer.title || '',
      'Hôtel': offer.title || '',
      'Type de chambre': room.name || '',
      'Pension': room.board || '',
      'Annulation': room.cancel || '',
      'Voyageurs': String(room.occupancy || ''),
      'Nombre de chambres': String(room.count || 1),
      'Check-in': offer.checkin || '',
      'Check-out': offer.checkout || '',
      'Nuits': String(nights),
      'Prix / nuit': money(room.night_cents, room.currency || offer.currency),
      'Prix séjour': money(room.price_cents, room.currency || offer.currency),
      'Catégorie': offer.stars ? (offer.stars + ' étoiles') : '',
      'Adresse': offer.address || '',
      'Note hôtel': offer.rating ? String(offer.rating) : '',
      'Lits': room.beds || '',
      'Détails chambre': (room.details || room.description || '').slice(0, 255),
      'Confirmation': 'Dossier sous 48 h ouvrées',
      'Référence live': room.id || offer.id || ''
    };
  }

  function updateStayRecap(root, offer, room) {
    var recap = qs('[data-stay-recap]', root);
    if (!recap) {
      return;
    }
    recap.hidden = false;
    var title = qs('[data-stay-recap-title]', recap);
    var meta = qs('[data-stay-recap-meta]', recap);
    var price = qs('[data-stay-recap-price]', recap);
    var night = qs('[data-stay-recap-night]', recap);
    var nights = room.nights || nightsCount(offer.checkin, offer.checkout);
    if (title) {
      title.textContent = (offer.title || '') + ' — ' + (room.name || '');
    }
    if (meta) {
      meta.textContent = [offer.city, (offer.checkin || '') + ' → ' + (offer.checkout || ''), room.board].filter(Boolean).join(' · ');
    }
    if (price) {
      price.textContent = money(room.price_cents, room.currency || offer.currency);
    }
    if (night) {
      night.textContent = money(room.night_cents, room.currency || offer.currency) + ' ' + t('per_night', '/ nuit') + ' · ' + tN('night_one', 'night_other', nights, '%n nuit', '%n nuits');
    }
  }

  function roomImages(room, offer) {
    var list = [];
    if (Array.isArray(room.images)) {
      list = room.images.slice();
    } else if (room.image) {
      list = [room.image];
    }
    if (!list.length && offer && offer.image) {
      list = [offer.image];
    }
    return list.filter(function (src) {
      return String(src || '').indexOf('https://') === 0;
    }).slice(0, 6);
  }

  function roomGalleryHtml(room, offer) {
    var images = roomImages(room, offer);
    if (!images.length) {
      return '<div class="live-room__media live-room__media--empty" aria-hidden="true"></div>';
    }
    var thumbs = images.length > 1
      ? '<div class="live-room__thumbs">' + images.map(function (src, index) {
        return '<button type="button" class="live-room__thumb' + (index === 0 ? ' is-active' : '') + '" data-room-thumb="' + escapeHtml(src) + '" aria-label="' + escapeHtml(t('photo', 'Photo')) + ' ' + (index + 1) + '">' +
          '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" width="72" height="54">' +
          '</button>';
      }).join('') + '</div>'
      : '';
    return '<div class="live-room__media">' +
      '<img class="live-room__photo" src="' + escapeHtml(images[0]) + '" alt="' + escapeHtml(room.name || t('room', 'Chambre')) + '" loading="lazy" width="420" height="280">' +
      thumbs +
      '</div>';
  }

  function renderRooms(panel, offer, query, root) {
    var rooms = offer.rooms && offer.rooms.length ? offer.rooms : liveRoomFallback(offer, query);
    panel.innerHTML = '';
    var heading = document.createElement('p');
    heading.className = 'live-rooms__title';
    heading.textContent = t('rooms_available', 'Chambres disponibles');
    panel.appendChild(heading);
    rooms.forEach(function (room) {
      var row = document.createElement('article');
      row.className = 'live-room';
      var nights = room.nights || nightsCount(offer.checkin, offer.checkout);
      var facts = [
        room.beds || '',
        room.board || '',
        tN('traveler_one', 'traveler_other', room.occupancy || 2, '%n voyageur', '%n voyageurs'),
        tN('night_one', 'night_other', nights, '%n nuit', '%n nuits'),
        room.cancel || ''
      ].filter(Boolean);
      var extras = String(room.details || '').split('·').map(function (item) {
        return item.trim();
      }).filter(Boolean).slice(0, 6);
      var description = room.description
        ? '<p class="live-room__text">' + escapeHtml(room.description) + '</p>'
        : '';
      var extraHtml = extras.length
        ? '<ul class="live-room__extras">' + extras.map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        }).join('') + '</ul>'
        : '';
      row.innerHTML =
        roomGalleryHtml(room, offer) +
        '<div class="live-room__body">' +
          '<h4 class="live-room__name">' + escapeHtml(room.name) + '</h4>' +
          description +
          '<ul class="live-room__facts">' + facts.map(function (item) {
            return '<li>' + escapeHtml(item) + '</li>';
          }).join('') + '</ul>' +
          extraHtml +
        '</div>' +
        '<div class="live-room__side">' +
          '<div class="live-room__price">' +
            '<strong>' + escapeHtml(money(room.price_cents, room.currency)) + '</strong>' +
            '<span>' + escapeHtml(money(room.night_cents, room.currency)) + ' ' + escapeHtml(t('per_night', '/ nuit')) + '</span>' +
          '</div>' +
          '<div class="live-room__actions"></div>' +
        '</div>';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn--primary';
      btn.textContent = t('book_room', 'Réserver cette chambre');
      btn.addEventListener('click', function () {
        stayBookRoom(root, offer, room, query);
      });
      qs('.live-room__actions', row).appendChild(btn);
      var photo = qs('.live-room__photo', row);
      qsa('[data-room-thumb]', row).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-room-thumb') || '';
          if (photo && src) {
            photo.src = src;
          }
          qsa('[data-room-thumb]', row).forEach(function (el) {
            el.classList.toggle('is-active', el === thumb);
          });
        });
      });
      panel.appendChild(row);
    });
  }

  function render(root, type, data) {
    var meta = qs('[data-live-meta]', root);
    var list = qs('[data-live-results]', root);
    if (!meta || !list) {
      return;
    }
    var count = (data.results || []).length;
    meta.textContent = data.message && count
      ? data.message
      : (type === 'stay'
        ? t('hotels_n', '%n hôtels disponibles en temps réel').replace('%n', String(count))
        : t('flights_n', '%n vols disponibles en temps réel').replace('%n', String(count)));
    list.innerHTML = '';
    (data.results || []).forEach(function (offer) {
      var card = document.createElement('article');
      card.className = type === 'stay' ? 'live-card live-card--stay' : 'live-card live-card--flight';
      var facts;
      var media = '';
      var nights = nightsCount(offer.checkin, offer.checkout);
      if (type === 'flight') {
        facts = [
          offer.airline,
          offer.flight_number,
          offer.duration_label || formatMinutes(offer.duration),
          offer.stops ? t('stops', '%n escale(s)').replace('%n', String(offer.stops)) : t('direct', 'Direct'),
          formatTime(offer.depart_at),
          offer.cabin,
          offer.trip_type
        ].filter(Boolean);
        media = offer.airline_logo
          ? '<img class="live-card__carrier" src="' + escapeHtml(offer.airline_logo) + '" alt="" width="56" height="56" loading="lazy">'
          : '<div class="live-card__carrier live-card__carrier--empty" aria-hidden="true"></div>';
      } else {
        facts = [
          offer.stars ? (offer.stars + '★') : '',
          offer.rating ? (t('rating', 'Note') + ' ' + offer.rating) : '',
          offer.reviews ? t('reviews', '%n avis').replace('%n', String(offer.reviews)) : '',
          offer.distance || offer.city
        ].filter(Boolean);
        media = offer.image
          ? '<img class="live-card__media" src="' + escapeHtml(offer.image) + '" alt="" loading="lazy" width="280" height="180">'
          : '<div class="live-card__media live-card__media--empty" aria-hidden="true"></div>';
      }
      var extras = type === 'stay'
        ? amenityList(offer.amenities).map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        }).join('')
        : '';
      var nightLine = type === 'stay' && offer.night_cents
        ? '<span class="live-card__night">' + escapeHtml(t('from_night', 'À partir de')) + ' ' + escapeHtml(money(offer.night_cents, offer.currency)) + ' ' + escapeHtml(t('per_night', '/ nuit')) + ' · ' + escapeHtml(tN('night_one', 'night_other', nights, '%n nuit', '%n nuits')) + '</span>'
        : '';
      var mainHtml =
        media +
        '<div class="live-card__body">' +
          '<span class="live-card__badge">' + escapeHtml(offer.provider || '') + '</span>' +
          '<p class="live-card__route">' + escapeHtml(type === 'flight' ? ((offer.origin || '') + ' → ' + (offer.destination || '')) : (offer.city || '')) + '</p>' +
          '<h3 class="live-card__title">' + escapeHtml(offer.title || '') + '</h3>' +
          '<ul class="live-card__facts">' + facts.map(function (f) { return '<li>' + escapeHtml(f) + '</li>'; }).join('') + '</ul>' +
          (extras ? '<ul class="live-card__amenities">' + extras + '</ul>' : '') +
          (type === 'flight' && offer.layovers ? '<p class="live-card__note">' + escapeHtml(t('layover', 'Escale :')) + ' ' + escapeHtml(offer.layovers) + '</p>' : '') +
        '</div>' +
        '<div class="live-card__foot">' +
          '<strong class="live-card__price">' + escapeHtml(money(offer.price_cents, offer.currency)) + '</strong>' +
          nightLine +
          '<div class="live-card__actions"></div>' +
        '</div>';
      card.innerHTML = type === 'stay'
        ? '<div class="live-card__main">' + mainHtml + '</div><div class="live-rooms" data-live-rooms hidden></div>'
        : mainHtml;
      var actions = qs('.live-card__actions', card);
      if (type === 'stay') {
        var bookBtn = document.createElement('button');
        bookBtn.type = 'button';
        bookBtn.className = 'btn btn--primary';
        bookBtn.textContent = t('book', 'Réserver');
        bookBtn.addEventListener('click', function () {
          var room = (offer.rooms && offer.rooms[0]) || liveRoomFallback(offer, data.query || {})[0];
          stayBookRoom(root, offer, room, data.query || {});
        });
        var roomsBtn = document.createElement('button');
        roomsBtn.type = 'button';
        roomsBtn.className = 'btn btn--outline';
        roomsBtn.textContent = t('see_rooms', 'Voir les chambres');
        roomsBtn.addEventListener('click', function () {
          var panel = qs('[data-live-rooms]', card);
          if (!panel) {
            return;
          }
          var opening = panel.hidden;
          if (opening && !panel.getAttribute('data-ready')) {
            offer.rooms = liveRoomFallback(offer, data.query || {});
            renderRooms(panel, offer, data.query || {}, root);
            var title = panel.querySelector('.live-rooms__title');
            if (title) {
              title.textContent = t('loading_rooms', 'Chargement des chambres…');
            }
            panel.hidden = false;
            roomsBtn.textContent = t('hide_rooms', 'Masquer les chambres');
            searchLiveRooms(root.getAttribute('data-live-endpoint') || '', offer, data.query || {}).then(function (rooms) {
              offer.rooms = rooms;
              renderRooms(panel, offer, data.query || {}, root);
              panel.setAttribute('data-ready', '1');
              panel.hidden = false;
              roomsBtn.textContent = t('hide_rooms', 'Masquer les chambres');
            });
            return;
          }
          panel.hidden = !opening;
          roomsBtn.textContent = panel.hidden ? t('see_rooms', 'Voir les chambres') : t('hide_rooms', 'Masquer les chambres');
        });
        actions.appendChild(bookBtn);
        actions.appendChild(roomsBtn);
      } else {
        var flightBtn = document.createElement('button');
        flightBtn.type = 'button';
        flightBtn.className = 'btn btn--primary';
        flightBtn.textContent = t('book', 'Réserver');
        flightBtn.addEventListener('click', function () {
          openFlightDossier(root, offer, data.query || {});
        });
        actions.appendChild(flightBtn);
      }
      list.appendChild(card);
    });
  }

  function formQuery(form) {
    var data = new FormData(form);
    return {
      origin: data.get('origin') || '',
      destination: data.get('destination') || '',
      depart: data.get('depart') || data.get('checkin') || '',
      return: data.get('return') || data.get('checkout') || '',
      checkin: data.get('checkin') || data.get('depart') || '',
      checkout: data.get('checkout') || data.get('return') || '',
      adults: parseInt(data.get('adults') || '1', 10) || 1,
      cabin: data.get('cabin') || 'economy',
      rooms: parseInt(data.get('rooms') || '1', 10) || 1,
      stars: parseInt(data.get('stars') || '0', 10) || 0,
      breakfast: data.get('breakfast') ? 1 : 0,
      wifi: data.get('wifi') ? 1 : 0,
      pool: data.get('pool') ? 1 : 0,
      cancel: data.get('cancel') ? 1 : 0
    };
  }

  function runSearch(root, form) {
    var type = root.getAttribute('data-live-type') || 'flight';
    var endpoint = root.getAttribute('data-live-endpoint') || '';
    var query = formQuery(form);
    if (type === 'stay' && !String(query.destination || '').trim()) {
      if (meta) {
        meta.textContent = t('need_dest', 'Indiquez une ville, un pays ou un hôtel pour voir les chambres.');
      }
      return;
    }
    var meta = qs('[data-live-meta]', root);
    if (meta) {
      meta.textContent = type === 'stay' ? t('searching_hotels', 'Recherche des hôtels en cours…') : t('searching', 'Recherche en cours…');
    }
    var recap = qs('[data-stay-recap]', root);
    if (recap) {
      recap.hidden = true;
    }
    var runner = type === 'stay' ? searchHotels(query, endpoint) : searchFlights(query, endpoint);
    runner.then(function (result) {
      var live = (result.results || []).filter(function (item) {
        return String(item.provider || '').toLowerCase().indexOf('sandbox') === -1
          && String(item.id || '').indexOf('sandbox-') !== 0;
      });
      result.results = live;
      result.query = query;
      if (!live.length) {
        throw new Error('empty');
      }
      render(root, type, result);
    }).catch(function (err) {
      var list = qs('[data-live-results]', root);
      if (list) {
        list.innerHTML = '';
      }
      if (meta) {
        meta.textContent = (err && err.userMessage) || t('no_offers', 'Aucune offre live disponible pour cette recherche.');
      }
    });
  }

  function bindPage(root) {
    var form = qs('[data-live-form]', root);
    if (!form) {
      return;
    }
    var params = new URLSearchParams(window.location.search);
    qsa('input, select', form).forEach(function (field) {
      var key = field.getAttribute('name');
      if (!key || !params.get(key)) {
        return;
      }
      if (field.type === 'checkbox') {
        field.checked = params.get(key) === '1' || params.get(key) === 'true';
      } else if (!field.value) {
        field.value = params.get(key);
      }
    });
    qsa('input[type="date"]', form).forEach(function (field) {
      field.min = todayIso();
    });
    var checkin = qs('[name="checkin"]', form);
    var checkout = qs('[name="checkout"]', form);
    var depart = qs('[name="depart"]', form);
    var retour = qs('[name="return"]', form);
    if (checkin && !checkin.value) {
      checkin.value = addDaysIso(14);
    }
    if (checkout && !checkout.value) {
      checkout.value = addDaysIso(17);
    }
    if (depart && !depart.value) {
      depart.value = addDaysIso(14);
    }
    if (retour && !retour.value && root.getAttribute('data-live-type') === 'flight') {
      retour.value = addDaysIso(21);
    }
    if (root.getAttribute('data-live-type') === 'stay') {
      var updateStaySummary = function () {
        var dest = String((qs('[name="destination"]', form) || {}).value || '').trim() || t('worldwide', 'Monde entier');
        var adultsVal = parseInt((qs('[name="adults"]', form) || {}).value || '2', 10) || 2;
        var roomsVal = parseInt((qs('[name="rooms"]', form) || {}).value || '1', 10) || 1;
        var nightsVal = nightsCount((checkin || {}).value, (checkout || {}).value);
        var nightsLabel = tN('night_one', 'night_other', nightsVal, '%n nuit', '%n nuits');
        var summary = qs('[data-stay-summary]', form);
        var nightsEl = qs('[data-stay-nights]', form);
        if (summary) {
          summary.textContent = tN('traveler_one', 'traveler_other', adultsVal, '%n voyageur', '%n voyageurs') + ' · ' + tN('room_one', 'room_other', roomsVal, '%n chambre', '%n chambres') + ' · ' + nightsLabel + ' · ' + dest;
        }
        if (nightsEl) {
          nightsEl.textContent = nightsLabel;
        }
        if (checkout && checkin && checkin.value) {
          checkout.min = checkin.value;
        }
      };
      form.addEventListener('input', updateStaySummary);
      form.addEventListener('change', updateStaySummary);
      updateStaySummary();
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      runSearch(root, form);
    });
    qsa('[data-stay-dest]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var dest = qs('[name="destination"]', form);
        if (dest) {
          dest.value = chip.getAttribute('data-stay-dest') || '';
          dest.dispatchEvent(new Event('input', { bubbles: true }));
        }
        qsa('[data-stay-dest]', root).forEach(function (el) {
          el.classList.toggle('is-active', el === chip);
        });
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });
    if (params.get('origin') || params.get('destination') || params.get('depart') || params.get('checkin')) {
      if (root.getAttribute('data-live-type') !== 'stay' || String(params.get('destination') || '').trim()) {
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    }
  }

  function bindHome() {
    var home = qs('[data-home-search]');
    var tabs = qs('[data-search-tabs]');
    if (!home || !tabs) {
      return;
    }
    var originField = qs('[data-field="origin"]', home);
    var destInput = qs('#SearchArrival, [name="destination"]', home);
    qsa('[data-tab]', tabs).forEach(function (tab) {
      tab.addEventListener('click', function () {
        qsa('[data-tab]', tabs).forEach(function (el) {
          el.classList.toggle('is-active', el === tab);
          el.setAttribute('aria-selected', el === tab ? 'true' : 'false');
        });
        var kind = tab.getAttribute('data-tab');
        if (originField) {
          originField.hidden = kind === 'sejours';
        }
        if (destInput) {
          destInput.placeholder = kind === 'sejours'
            ? ((window.SAMATRIP && SAMATRIP.i18n && SAMATRIP.i18n.hotelPh) || 'Ville ou hôtel dans le monde')
            : ((window.SAMATRIP && SAMATRIP.i18n && SAMATRIP.i18n.destPh) || 'Ville d\'arrivée');
        }
      });
    });
    var form = qs('form', home) || home;
    form.addEventListener('submit', function (event) {
      var active = qs('[data-tab].is-active', tabs);
      var kind = active ? active.getAttribute('data-tab') : 'vols';
      if (kind === 'packages') {
        return;
      }
      event.preventDefault();
      var origin = (qs('[name="q"]', home) || {}).value || '';
      var destination = (qs('[name="destination"]', home) || {}).value || '';
      var depart = (qs('[name="date_depart"]', home) || {}).value || '';
      var retour = (qs('[name="date_retour"]', home) || {}).value || '';
      var travelers = (qs('[name="travelers"]', home) || {}).value || '1';
      var adults = parseInt(String(travelers), 10) || 1;
      var url;
      if (kind === 'sejours') {
        url = '/pages/sejours?destination=' + encodeURIComponent(destination || origin) +
          '&checkin=' + encodeURIComponent(depart) +
          '&checkout=' + encodeURIComponent(retour) +
          '&adults=' + encodeURIComponent(String(adults));
      } else {
        url = '/pages/vols?origin=' + encodeURIComponent(origin) +
          '&destination=' + encodeURIComponent(destination) +
          '&depart=' + encodeURIComponent(depart) +
          '&return=' + encodeURIComponent(retour) +
          '&adults=' + encodeURIComponent(String(adults));
      }
      window.location.href = url;
    });
  }

  function prefillProduct() {
    var form = qs('form.product-form');
    if (!form) {
      return;
    }
    var q = new URLSearchParams(window.location.search);
    var map = {
      origin: ['Ville de départ'],
      destination: ['Ville d\'arrivée', 'Destination séjour', 'Destination'],
      depart: ['Date départ', 'Check-in'],
      retour: ['Date retour', 'Check-out'],
      checkin: ['Check-in', 'Date départ'],
      checkout: ['Check-out', 'Date retour'],
      ref: ['Référence live']
    };
    Object.keys(map).forEach(function (key) {
      if (!q.get(key)) {
        return;
      }
      map[key].forEach(function (prop) {
        var field = qs('[name="properties[' + prop + ']"]', form);
        if (field && !field.value) {
          field.value = q.get(key);
        }
      });
    });
  }

  qsa('[data-live-search]').forEach(bindPage);
  qsa('[data-booking-dossier], [data-flight-dossier]').forEach(bindBookingDossier);
  bindHome();
  prefillProduct();

  SAMATRIP.LiveSearch = {
    searchFlights: searchFlights,
    searchHotels: searchHotels
  };
  window.SAMATRIP = SAMATRIP;
})(window);
